<template>
    <StepTemplate :activeStepNr="this.activeStepNr"
                  :myStepNr="this.myStepNr"
                  :value="value"

    >
        <template slot="slide-form">

            <form data-vv-scope="xxx" @click.alt="testFillForm()">
                <!--============================================================================================================ -->

                <template v-for="radNr in parseInt(value.fieldValues.raeder_ARRAY_counter,10)" >
                    <div :key="radNr">
                    <v-layout row class="section_header">
                        <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>zu versicherndes <span
                                v-if="value.fieldValues.raeder_ARRAY_counter>1">{{radNr}}.</span> Fahrrad</h6></v-flex>
                    </v-layout>
                        <!------------------------------------------------------------------------------------------------------------>
                        <v-layout row>
                            <v-flex xs12 style=" font-size: 0.9em;">
                                <Anzeigepflicht-Block><!-- TextBlock mit Hinweis zur Pflicht alle Daten korrekt anzugeben--></Anzeigepflicht-Block>
                            </v-flex>
                        </v-layout>
                        <!------------------------------------------------------------------------------------------------------------>
                    <v-layout row style="border-top:solid 1px grey;border-bottom:solid 1px grey; padding: 10px 0 0 0">
                        <v-flex xs12>
                            Das zu versichernde Fahrrad/Rollstuhl darf nicht der Führerschein-/Versicherungspflicht
                            unterliegen, sowie nicht zum gewerblichem Verleih genutzt werden.
                            <br>
                            <br>
                        </v-flex>
                    </v-layout>
                    <!------------------------------------------------------------------------------------------------------------>
                    <v-layout row>
                        <Rechner-hint-col>
                            Bitte wählen Sie hier, was für ein Risiko Sie versichern wollen.
                            <ul>
                                <li>Handelt es sich um ein handelsübliches Fahrrad, E-Bike oder Rollstuhl?</li>
                                <li>Ist es ein Carbon Fahrrad?</li>
                                <li>Oder sollen einzelne Carbon-Komponente versichert werden?</li>
                            </ul>
                        </Rechner-hint-col>
                        <v-flex xs10>
                            <Rechner-field-col :fielddef="fieldDefs['raeder_ARRAY_kategorie_'+radNr]"
                                               v-model="value.fieldValues"
                                               direction="column"
                                               :$v="$v"
                                               @input="forceUpdateHack()"
                            ></Rechner-field-col>
                        </v-flex>
                    </v-layout>
                    <!--============================================================================================================ -->
                    <v-layout row>
                        <Rechner-hint-col>
                            Geben Sie hier die Marke bzw. den Hersteller Ihres E-Bikes, Fahrrades oder Rollstuhls an!
                        </Rechner-hint-col>
                        <v-flex xs10>
                            <Rechner-field-col :fielddef="fieldDefs['raeder_ARRAY_marke_'+radNr]"
                                               v-model="value.fieldValues"
                                               :$v="$v"></Rechner-field-col>
                        </v-flex>
                    </v-layout>

                    <!------------------------------------------------------------------------------------------------------------>
                    <!--
                    <v-layout row v-if="value.fieldValues['raeder_ARRAY_kategorie_'+radNr] != 'KatTeile'">
                        <Rechner-hint-col>
                            Um was für ein Fahrrad handelt es sich?
                            <br>z.B. Mountainbike, Hollandrad, Rennrad, Trekkingrad etc.
                        </Rechner-hint-col>
                        <v-flex xs10>
                            <Rechner-field-col :fielddef="fieldDefs['raeder_ARRAY_typ_'+radNr]"
                                               v-model="value.fieldValues"
                                               :$v="$v"></Rechner-field-col>
                        </v-flex>
                    </v-layout>
                    -->
                    <!------------------------------------------------------------------------------------------------------------>
                    <v-layout row>
                        <Rechner-hint-col>
                            <div v-if="value.fieldValues['raeder_ARRAY_kategorie_'+radNr] == 'KatTeile'">
                                <b>Teielart:</b>:
                                <br>Wählen Sie hier die Art der zu versichernden Einzelteile
                            </div>
                            <div v-else>
                                <br>
                                <b>Baujahr</b>:
                                <br>Geben Sie hier das Baujahr Ihres Fahrrades an!
                            </div>
                            <div>
                                <br>
                                <b>Rahmennummer</b>:
                                <br>Tragen Sie hier bitte die Rahmennummer des zu versichernden E-Bikes, Fahrrades oder Rollstuhls ein.
                            </div>


                        </Rechner-hint-col>
                        <v-flex xs5 v-if="value.fieldValues['raeder_ARRAY_kategorie_'+radNr] == 'KatTeile'">
                            <Rechner-field-col :fielddef="fieldDefs['raeder_ARRAY_teileart_'+radNr]"
                                               v-model="value.fieldValues"
                                               :$v="$v"></Rechner-field-col>
                        </v-flex>
                        <v-flex xs5 v-else>
                            <Rechner-field-col :fielddef="fieldDefs['raeder_ARRAY_baujahr_'+radNr]"
                                               v-model="value.fieldValues"
                                               :$v="$v"></Rechner-field-col>
                        </v-flex>
                        <v-flex xs5>
                            <Rechner-field-col :fielddef="fieldDefs['raeder_ARRAY_rahmennr_'+radNr]"
                                               v-model="value.fieldValues"
                                               :$v="$v"></Rechner-field-col>
                        </v-flex>
                    </v-layout>

                    <!------------------------------------------------------------------------------------------------------------>
                    <v-layout row>
                        <Rechner-hint-col>
                            <b>Kaufdatum:</b>
                            <br>Geben Sie hier das Datum an, wann das zu versichernde E-Bike, Fahrrad oder Rollstuhl erworben wurde!
                            <br>
                            <br>
                            <b>Versicherungssumme:</b>
                            <br>Die Versicherungssumme ist gleich dem Kaufpreis des zu versichernden E-Bikes, Fahrrades oder Rollstuhls.
                        </Rechner-hint-col>
                        <v-flex xs5>
                            <Rechner-field-col :fielddef="fieldDefs['raeder_ARRAY_kaufdatum_'+radNr]"
                                               v-model="value.fieldValues"
                                               :$v="$v"></Rechner-field-col>
                        </v-flex>
                        <v-flex xs5>
                            <Rechner-field-col :fielddef="fieldDefs['raeder_ARRAY_kaufpreis_'+radNr]"
                                               v-model="value.fieldValues"
                                               :$v="$v"
                                               suffix="€"
                                               v-if="forceUpdateHack_hiddenSwitch==true"
                            ></Rechner-field-col>
                        </v-flex>

                    </v-layout>
                    <!------------------------------------------------------------------------------------------------------------>
                    </div>
                </template>
                <!--============================================================================================================-->
                <v-layout row class="section_header">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Beginn und Zahlungsweise</h6></v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <!--
                <v-layout row>
                    <Rechner-hint-col>
                        raeder_gewerblich_jn
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.raeder_gewerblich_jn"
                                           v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                -->
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Sie können den Versicherungsbeginn bestimmen!
                        <br>Der Beginn ist frühestens am nächsten Tag möglich.
                        <br>Der Versicherungsbeginn sollte jedoch maximal einen Tag später sein, zu dem Ihre bisherige Versicherung aufgehoben wurde.

                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.vertrag_beginn" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>

                <v-layout row>
                    <Rechner-hint-col>
                        Hier können Sie wählen, ob der Versicherungs-Beitrag einmal im Jahr, halbjährlich oder vierteljährlich gezahlt werden soll.
                        <br>Eine monatliche Zahlweise ist nicht möglich.

                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.vertrag_zahlungsweise" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>

                <!------------------------------------------------------------------------------------------------------------>

                <!--
                                <v-layout row>
                                    <v-flex xs5>
                                        <v-btn style="width:100%" @click.native="add_fahrrad()"
                                               :disabled="parseInt(value.fieldValues.raeder_ARRAY_counter,10) >= 10">
                                            weiteres Fahhrad hinzu

                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs5>
                                        <v-btn style="width:100%" @click.native="remove_fahrrad()"
                                               :disabled="parseInt(value.fieldValues.raeder_ARRAY_counter,10) <= 1">
                                            letztes Fahrrad entfernen

                                        </v-btn>
                                    </v-flex>

                                </v-layout>
                                -->

                <!------------------------------------------------------------------------------------------------------------>
            </form>

        </template>
    </StepTemplate>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
  import slideMixin from '../stepMixin'
  import _ from 'lodash'

  //import {mapState} from 'vuex'

  export default {
    //========================================================================================================
    name: 'Fahrrad-Daten',
    label: 'Fahrrad-Daten',
    label2: 'Fahrrad<br>Daten',
    fieldKeys: [
      'raeder_ARRAY_counter',
      'raeder_ARRAY_kategorie_1',
      'raeder_ARRAY_marke_1',
      /* 'raeder_ARRAY_typ_1', */
      'raeder_ARRAY_baujahr_1',
      'raeder_ARRAY_kaufdatum_1',
      'raeder_ARRAY_rahmennr_1',
      'raeder_ARRAY_kaufpreis_1',
      'raeder_ARRAY_teileart_1',

      'raeder_gewerblich_jn',

      'vertrag_zahlungsweise',
      'vertrag_beginn',

    ],
    //========================================================================================================
    data: function () {
      //fieldDefs wird in StepMixin mit den Werten aus der Datenbank belegt,
      //an dieser Stelle können diese Werte überschrieben werden.
      // Vue merged von alleine die Werte aus 'stepMixin' und denen aus 'fieldDefs_OVERRIDE'
      var fieldDefs_OVERRIDE = {}

      return {
        forceUpdateHack_hiddenSwitch: true,
        fieldDefs: fieldDefs_OVERRIDE,
        forceUpdateDummy: 1,

      }
    }, //========================================================================================================
    mixins: [slideMixin],
    //===========================================================================================================
    methods: {
      forceUpdateHack: function () {
        console.log("** test **")
        this.forceUpdateHack_hiddenSwitch = false
        this.$nextTick(function () {
          this.forceUpdateHack_hiddenSwitch = true
        })

      },
      //___________________________________________________________________________________________________________
      add_fahrrad: function () {
        console.log("######## RAD+ ###############")
        var newCount = parseInt(this.value.fieldValues.raeder_ARRAY_counter, 10) + 1
        _.forEach(this.$options.fieldKeys, (fieldName) => {
          console.log(fieldName, fieldName.indexOf("raeder_ARRAY_"))
          if ((/raeder_ARRAY_(.*)_1/g).exec(fieldName) && fieldName !== 'raeder_ARRAY_counter') {
            var new_Def = _.assign({}, this.$store.state.rechnerConfig.fieldDefs[fieldName])
            new_Def.name = new_Def.name.replace('_1', '_' + newCount)
            this.$options.fieldKeys.push(new_Def.name)
            console.log("&&& 1")
            this.fieldDefs[new_Def.name] = new_Def
            this.$store.commit('add_FieldDef', {data: new_Def})
            console.log("&&& 2")


            var defaultValue = new_Def.default_value
            if (defaultValue !== null && defaultValue !== undefined) {
              defaultValue = String(defaultValue);
            }

            this.$set(this.value.fieldValues, new_Def.name, defaultValue)
            console.log("&&& 3")
          }
        })

        console.log("&&& 4")
        this.forceUpdateDummy = this.forceUpdateDummy + 1
        this.$v.$reset();
        this.$nextTick(() => {
          this.value.fieldValues.raeder_ARRAY_counter = newCount
        })
        console.log("&&& 5")


      },
      //___________________________________________________________________________________________________________
      remove_fahrrad: function () {
        console.log("######## RAD- ###############")
        var olCount = parseInt(this.value.fieldValues.raeder_ARRAY_counter, 10)
        this.value.fieldValues.raeder_ARRAY_counter = olCount - 1
        this.$nextTick(() => {

          _.forEach(this.$options.fieldKeys, (fieldName) => {
            console.log(fieldName, this.$options.fieldKeys)
            //console.log(fieldName, fieldName.indexOf("raeder_ARRAY_"))
            if ((/raeder_ARRAY_(.*)_1/g).exec(fieldName) && fieldName !== 'raeder_ARRAY_counter') {
              var removeFieldName = fieldName.replace('_1', '_' + olCount)

              _.remove(this.$options.fieldKeys, function (n) {
                return (n === removeFieldName);
              })

              _.unset(this.fieldDefs, removeFieldName);

              this.$store.commit('remove_FieldDef', {data: removeFieldName})
              console.log("&&& 2")

              this.$delete(this.value.fieldValues, removeFieldName)
              console.log("&&& 3")
            }
          })
          this.$v.$reset();
          console.log("&&& 4")
          this.forceUpdateDummy = this.forceUpdateDummy + 1

        })
        console.log("&&& 5")


      },
    }, //========================================================================================================
    watch: {

      value: {
        handler: function (newVal, oldVal) {
          console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
          console.log("WATCHER fieldValues in ", this.$options.label)
          var fV = this.value.fieldValues
          var fVold = this.frmValuesOld
          // var fD = this.fieldDefs
          var earlyExit = true;
          for (var key in fV) {
            if (fV[key] !== fVold[key]) {
              earlyExit = false
              console.log("changed ", key, fVold[key], '->', fV[key])
            }
          }
          if (earlyExit === true) {
            console.log("NO changes -> early EXIT in Fahrrad_I")
            return;
          }

          //----------------------------------------------------------------------------
          var radCount = parseInt(this.value.fieldValues.raeder_ARRAY_counter, 10)
          console.log("checks for " + radCount + " Räder :")
          for (var radNr = 1; radNr <= radCount; radNr++) {
            console.log("WATCHER: for Rad Nr " + radNr)
            var newKat = this.value.fieldValues['raeder_ARRAY_kategorie_' + radNr]
            var oldKat = fVold['raeder_ARRAY_kategorie_' + radNr]

            if (newKat === 'KatTeile' && oldKat !== newKat) {
              // this.value.fieldValues['raeder_ARRAY_marke_' + radNr] = "-/-";
              this.value.fieldValues['raeder_ARRAY_typ_' + radNr] = "-/-";
              this.value.fieldValues['raeder_ARRAY_baujahr_' + radNr] = "2200";
              this.value.fieldValues['raeder_ARRAY_teileart_' + radNr] = null;
              console.log("WATCHER: set kategorie auf 'KatTeile' => set uneeded to -/-")
            }
            if (newKat !== 'KatTeile' && oldKat === 'KatTeile') {
              // this.value.fieldValues['raeder_ARRAY_marke_' + radNr] = null;
              this.value.fieldValues['raeder_ARRAY_typ_' + radNr] = null;
              this.value.fieldValues['raeder_ARRAY_baujahr_' + radNr] = null;
              this.value.fieldValues['raeder_ARRAY_teileart_' + radNr] = "-/-";
              console.log("WATCHER: set kategorie NOT 'KatTeile' => set uneeded to -/-")
            }

          }
          //----------------------------------------------------------------------------
          this.frmValuesOld = _.assign({}, fV)


        },
        deep: true,

      },
    }, //========================================================================================================
    components: {/* programmatically setted by step-mixin*/},
    //===========================================================================================================
    props: [/* programmatically setted by step-mixin*/],
    //===========================================================================================================
    // HOOKS:
    /* programmatically setted by step-mixin*/
    //===========================================================================================================
  }
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>

</style>
